import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=6b5c1fd6&scoped=true"
var script = {}
import style0 from "./divider.vue?vue&type=style&index=0&id=6b5c1fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c1fd6",
  null
  
)

export default component.exports